module.exports = __webpack_public_path__ + "media/src/website/images/locations/oberschleissheim/profile-015855275165db3857dd82c9ecf7ccd1.jpg";